import type { PartnerGeneralResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Grid2, Typography } from "@mui/material";

type ReplacedPartnerWidgetProps = {
	partner: PartnerGeneralResponseDto;
};

const partnerCardResource = Resources.base.partner.cards;
const infoResources = Resources.base.order.detail.info;

export function ReplacedPartnerWidget({ partner }: ReplacedPartnerWidgetProps) {
	const { t } = useResource();
	const { fullName, email, phone } = partner;

	return (
		<BaseCard title={t(partnerCardResource.replaced)}>
			<Grid2 container>
				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(infoResources.name)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{fullName}
					</Typography>
				</Grid2>

				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(infoResources.phone)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{phone}
					</Typography>
				</Grid2>

				<Grid2 size={12} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(infoResources.email)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{email}
					</Typography>
				</Grid2>
			</Grid2>
		</BaseCard>
	);
}
